module.exports = __webpack_public_path__ + "img/bandera_usa.3ff02b43.svg";